export const locForm: any = {
  locationName: "",
  locationType: "",
  description: "",
  organization: "",
  locationId: "",
  business: [],
  users: [],
  functionId: [],
  id: "",
  businessTypeId : "",
};
